// extracted by mini-css-extract-plugin
export var circle = "_ao-1";
export var exitConfirmationModal = "_ao-5";
export var iframe = "_ao-0";
export var offline = "_ao-3";
export var online = "_ao-2";
export var workstationSelectError = "_ao-4";